import { useId } from 'react';

/**
 * Ported from src/components/ui/TextField.tsx. `onChangeText` matches the React Native
 * signature so screens ported from the app do not have to unwrap events.
 */
export default function TextField({
  label,
  value,
  onChangeText,
  placeholder,
  multiline = false,
  type = 'text',
  error,
  autoFocus,
  rows = 4,
}: {
  label?: string;
  value: string;
  onChangeText: (text: string) => void;
  placeholder?: string;
  multiline?: boolean;
  type?: 'text' | 'email' | 'password' | 'search';
  error?: string;
  autoFocus?: boolean;
  rows?: number;
}) {
  const id = useId();
  const errorId = `${id}-error`;
  const shared = {
    id,
    value,
    placeholder,
    autoFocus,
    'aria-invalid': error ? (true as const) : undefined,
    'aria-describedby': error ? errorId : undefined,
    className: `field ${error ? 'field-error' : ''}`.trim(),
    onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => onChangeText(e.target.value),
  };
  return (
    <div className="field-wrap">
      {label && <label htmlFor={id} className="type-caption field-label">{label}</label>}
      {multiline ? <textarea {...shared} rows={rows} /> : <input {...shared} type={type} />}
      {error && <p id={errorId} role="alert" className="type-caption field-error-text">{error}</p>}
    </div>
  );
}
